import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { HttpClient } from '@angular/common/http';
import { CryptoService } from '../crypto.service';
import { CaesarComponent } from '../caesar/caesar.component';
import { letterFrequencies, trigramFrequencies, bigramFrequencies } from '../../../assets/constant';
import { SkytaleComponent } from '../skytale/skytale.component';
import { MonoalphabeticComponent } from '../monoalphabetic/monoalphabetic.component';
import { CryptoView } from '../crypto-view';

@Component({
  selector: 'app-t-decode-without-key',
  templateUrl: './t-decode-without-key.component.html',
  styleUrls: ['../topic-style.css', './t-decode-without-key.component.css']
})
export class TDecodeWithoutKeyComponent extends GeneralTeacherComponent {

  @ViewChild('caesar', {static:true})
  private caesar: CaesarComponent;


  @ViewChild('skytale', {static:true})
  private skytale: SkytaleComponent;

  @ViewChild('monoalphabetic', {static:true})
  private monoalphabetic: MonoalphabeticComponent;


  @ViewChild('setKey', {static:true})
  private setKeyView: MonoalphabeticComponent;

  private view: CryptoView;

  method: string;
  keyN: number;
  keyS: string = " ".repeat(26);
  get keyP() {
    if (this.method == "caesar" || this.method == "skytale") {
      return this.keyN;
    }
    if (this.method == "monoalphabetic") {
      return this.keyS;
    }
  }

  set keyP(value: any) {
    if (this.method == "caesar" || this.method == "skytale") {
      if (value || value == 0) {
        this.keyN = +value;
      } else {
        this.keyN = undefined;
      }
    }
    if (this.method == "monoalphabetic") {
      if (value) {
        this.keyS = value;
      } else {
        this.keyS = undefined;
      }
    }
  }
  plainText: string;
  cipherText: string;
  modus: string = "normal";
  text: any;
  hints: string = "";
  showStats: boolean = true;
  showBigrams: boolean = false;
  showTrigrams: boolean = false;
  decodeAutomatically: boolean = true;
  minimalLength: number = 50;

  frequency: any[] = [];
  bigrams: any[] = [];
  trigrams: any[] = [];

  standardFrequencies = letterFrequencies;
  trigramFrequencies = trigramFrequencies;
  bigramFrequencies = bigramFrequencies;

  language: string;

  dataFrequencies: any[] = [];
  dataBigram: any[] = [];
  dataTrigram: any[] = [];



  constructor(topicService: TopicService, activatedRoute: ActivatedRoute, protected http: HttpClient, public cryptoService: CryptoService) {
    super(topicService, activatedRoute)
    this.type = "decodeWithoutKey"
    this.loadText();
    this.title = this.get("decodeWithoutKey");
    this.language = this.topicService.getLanguage();
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<string>(textFile)
        .subscribe(response => {
          self.text = response;
          resolve(true);
        })
    })
  }

  /** sets information based on configuration */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.method = this.configuration.typespecifics.method;
    switch (this.method) {
      case "caesar": this.view = this.caesar; break;
      case "skytale": this.view = this.skytale; break;
      case "monoalphabetic": this.view = this.monoalphabetic; break;
    }
    this.keyP = this.configuration.typespecifics.key;
    this.cipherText = this.configuration.typespecifics.text;
    this.modus = this.configuration.typespecifics.modus;
    this.plainText = this.cryptoService.decode(this.method, this.keyP, this.cipherText);
    this.hints = this.configuration.typespecifics.hints;
    this.cryptoService.computefrequencies(this.frequency, this.bigrams, this.trigrams, this.plainText);
    this.showStats = this.configuration.typespecifics.showStats;
    this.showBigrams = this.configuration.typespecifics.showBigrams;
    this.showTrigrams = this.configuration.typespecifics.showTrigrams;
    this.decodeAutomatically = this.configuration.typespecifics.decodeAutomatically;
    this.onChangeHints();
  }


  generateDefinition(): any {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/decryptWithoutKey.png";
    definition.level = (this.hints.length == 0 ? 2 : 1)
    definition.key = "crypto%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.method = this.method;
    definition.typespecifics.key = this.keyP;
    definition.typespecifics.text = this.cipherText;
    definition.typespecifics.modus = this.modus;
    definition.typespecifics.hints = this.hints;
    definition.typespecifics.showStats = this.method == "skytale" ? false : this.showStats;
    definition.typespecifics.showBigrams = this.method == "skytale" ? false : (this.showStats ? this.showBigrams : false);
    definition.typespecifics.showTrigrams = this.method == "skytale" ? false : (this.showStats ? this.showTrigrams : false);
    definition.typespecifics.decodeAutomatically = this.method == "monoalphabetic" ? false : this.decodeAutomatically;
    definition.key = definition.key.concat("%", this.method.toString(), "%", this.keyP, "%", this.cipherText.slice(0, 20));

    return definition;
  }

  reset() {
    super.reset();
    this.title = this.get("decodeWithoutKey");
    this.modus = "normal";
    this.hints = "";
    this.view.setHints([]);
    this.method = undefined;
    this.keyP = undefined;
    this.keyN = undefined;
    this.keyS = " ".repeat(26);
    this.plainText = "";
    this.cipherText = "";
    this.frequency = [];
    this.bigrams = [];
    this.trigrams = [];
  }

  /**
   * normalizes the text, computes the frequencies and computes the cipher
   */
  onChangeEncoding() {
    if (this.plainText) {
      this.plainText = this.cryptoService.normalizeText(this.plainText);
      this.cryptoService.computefrequencies(this.frequency, this.bigrams, this.trigrams, this.plainText);
      this.dataFrequencies = [];
      let index = 0;
      for (let c of this.standardFrequencies[this.language]) {
        this.dataFrequencies.push({
          name: c.key.concat(" ", this.frequency[index].key),
          series: [
            {
              name: this.get("standardFrequencies"),
              value: +c.value
            },
            {
              name: this.get("cipherFrequencies"),
              value: this.frequency[index].value
            }
          ]
        });
        index++;
      }
      this.dataBigram = [];
      index = 0;
      for (let c of this.bigramFrequencies[this.language]) {
        this.dataBigram.push({
          name: c.key.concat(" ", this.bigrams[index].key),
          series: [
            {
              name: this.get("standardFrequencies"),
              value: +c.value
            },
            {
              name: this.get("cipherFrequencies"),
              value: this.bigrams[index].value
            }
          ]
        });
        index++;
      }
      this.dataTrigram = [];
      index = 0;
      for (let c of this.trigramFrequencies[this.language]) {
        this.dataTrigram.push({
          name: c.key.concat(" ", this.trigrams[index].key),
          series: [
            {
              name: this.get("standardFrequencies"),
              value: +c.value
            },
            {
              name: this.get("cipherFrequencies"),
              value: this.trigrams[index].value
            }
          ]
        });
        index++;
      }
      console.log(this.dataFrequencies);

    }
    if (this.method && (this.keyP || this.keyP == 0)) {
      switch (this.method) {
        case "caesar": this.view = this.caesar; break;
        case "skytale": this.view = this.skytale;
          this.keyP = Math.max(Math.min(this.keyP, 10), 2);
          this.showStats = false;
          this.showBigrams = false;
          this.showTrigrams = false;
          break;
        case "monoalphabetic": this.view = this.monoalphabetic; break;
      }
      switch (this.method) {
        case "caesar": {
          this.keyP = this.keyP % 26;
          if (this.keyP < 0) { this.keyP += 26; }
        }
      }
      if (this.plainText) {
        this.cipherText = this.cryptoService.encode(this.method, this.keyP, this.plainText);
      }
      this.onChangeHints();
    }
  }

  /** computes and sets the hints */
  onChangeHints() {
    if (this.method && (this.keyP || this.keyP == 0)) {
      this.hints = this.cryptoService.normalizeText(this.hints);
      let hintsToWrite = [];
      for (let hint of this.hints) {
        hintsToWrite[this.cryptoService.decode(this.method, this.keyP, hint).charCodeAt(0) - 65] = hint;
      }
      this.view.setHints(hintsToWrite);
      this.setKeyView.setHints(hintsToWrite);
    }
  }

  generate() {
    let methodCode = Math.floor(Math.random() * 3);
    this.keyN = Math.floor(Math.random() * 26);
    this.generateText();
    switch (methodCode) {
      case 0: this.method = "caesar"; break;
      case 1: this.method = "monoalphabetic"; this.generateKey(); break;
      case 2: this.method = "skytale"; this.keyN = Math.floor(this.keyN / 4) + 2; break;

    }
    this.generateText();
    this.title = this.get("decodeWithoutKey");
    this.modus = "normal";
    this.hints = "";
    this.onChangeEncoding();
    this.onChangeHints();
  }

  /**
   * generates some text
   */
  generateText() {
    let phrases = this.text.text.split(/[.!?]/).map(v => v.trim()).filter(v => v.trim().length > this.minimalLength);
    let index = Math.floor(Math.random() * phrases.length);
    this.plainText = this.cryptoService.normalizeText(phrases[index]);
    this.onChangeEncoding();

  }

  /**
   * generates a monoalphabeitcal key
   */
  generateKey() {
    this.keyS = "";
    //this.hints ="";
    this.onChangeHints();
    this.view.resetmapping();
    this.setKeyView.resetmapping();
    let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    this.keyS = "";
    while (chars.length > 0) {
      let i = Math.floor(Math.random() * chars.length);
      this.keyS = this.keyS.concat(chars[i]);
      chars.splice(i, 1);
    }
    this.onChangeEncoding();
  }

  getMethodDescription() {
    switch (this.method) {
      case "caesar": return this.get("useCaesar");
      case "polybius": return this.get("usePolybius");
      case "skytale": return this.get("useSkytale");
      case "monoalphabetic": return this.get("useMonoalphabetic");
      case "vignere": return this.get("useMask");
      case "vignereDigits": return this.get("useMask");
      case "vignereLetters": return this.get("useMask");
      case "pigpen": return this.get("usePigpen");
      case "atbash": return this.get("useAtbash");
      case "morse": return this.get("useMorse");
    }
  }

}
